export default function isTextSelectionEvent(e: Event) {
    return !!e && Boolean(window.getSelection()?.toString());
}
